import { cva } from 'class-variance-authority';

export const viewportStyle =
  'hidden xl:block absolute left-1/2 -translate-x-1/2 top-full z-50 w-max max-w-none rounded-[10px] border-2 border-white/20 bg-testimonialCardGradient backdrop-blur-md data-[state=open]:animate-scaleIn data-[state=closed]:animate-scaleOut origin-center';

export const menuLinkStyle =
  'lg:h-20 py-4 hover:text-primary-100 cursor-pointer border-none bg-transparent text-white transition-colors duration-150 [&[data-state=open]]:text-primary-100';

export const calloutCardContainer =
  'xl:mt-4 flex h-auto w-full flex-col items-start gap-8 rounded-lg border border-primary-200/10 bg-pricingCardGradient p-4 sm:h-auto md:flex-row md:justify-between md:flex-col md:gap-8 lg:flex-col lg:gap-8 xl:min-h-[249px] xl:w-[300px] xl:flex-col xl:gap-4 shrink-0 self-start';

export const miniCallOutStyle = cva(
  'group flex w-full shrink-0 flex-col gap-4 rounded-xl border border-primary-200/10 bg-pricingCardGradient p-3 sm:flex-row sm:justify-between',
  {
    variants: {
      context: {
        inside: 'relative max-w-full !flex-row items-center gap-3 xl:w-auto',
        standalone: 'xl:w-[233px] xl:flex-col',
      },
      hasFeaturedImage: {
        true: 'sm:flex-col',
        false: '',
      },
    },
    defaultVariants: {
      context: 'standalone',
      hasFeaturedImage: false,
    },
  },
);

export const columnContainer = cva(['flex items-start'], {
  variants: {
    direction: {
      column: 'w-full flex-col gap-4',
      row: 'w-max flex-row flex-nowrap items-start gap-[31px]',
    },
  },
});

export const menuItemStyle = cva([''], {
  variants: {
    direction: {
      column: 'w-full',
      row: 'shrink-0',
    },
  },
});

export const mobileMenuItemStyle = cva([''], {
  variants: {
    direction: {
      column: 'flex flex-col gap-6.5',
      row: 'flex flex-col gap-6.5',
    },
    multiColumn: {
      true: '',
      false: '',
    },
  },
  defaultVariants: {
    direction: 'column',
    multiColumn: false,
  },
});

export const menuItemListStyle = cva([''], {
  variants: {
    direction: {
      column: 'flex flex-wrap gap-4',
      row: 'flex flex-col gap-3',
    },
  },
});

// eslint-disable-next-line tailwindcss/enforces-negative-arbitrary-values
export const hamburgerLineStyle = cva(
  'absolute left-0 block h-0.5 w-full rotate-0 bg-white transition-all duration-300',
  {
    variants: {
      line: {
        0: 'top-0  group-aria-[expanded=true]:top-1.5 group-aria-[expanded=true]:rotate-[135deg]',
        1: 'top-1.5 group-aria-[expanded=true]:-left-5 group-aria-[expanded=true]:opacity-0',
        2: 'top-3 group-aria-[expanded=true]:top-1.5 group-aria-[expanded=true]:-rotate-[135deg]',
      },
    },
  },
);
